import React, { useEffect, useState } from "react";

import { useHistory } from "react-router";
import { Card, Divider, Skeleton } from "@mui/material";
import PostAddIcon from "@mui/icons-material/PostAdd";

import {
  consultarDatosSolicitud,
} from "../services/transaccionalService";
import DetalleOpcionGenerica from "./DetalleOpcionGenerica";

import { SCSGenericButton } from "app/modules/common/components/Buttons/SCSButtons";

const DetalleDatosSolicitud = ({
  cabenceraTransaccional,
  datosBusqueda,
  alturaResolucion,
}) => {
  const [datosSolicitud, setDatosSolicitud] = useState({});
  const [datosAumentoMonto, setDatosAumentoMonto] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const history = useHistory();

  useEffect(() => {
    const getData = async () => {
      try {
        const respuestaEstadosCredito = await consultarDatosSolicitud(
          datosBusqueda.identificacion,
          datosBusqueda.idGrupo
        );

        /*  console.log(respuestaEstadosCredito); */

        if (respuestaEstadosCredito.state && respuestaEstadosCredito.data) {
          setDatosSolicitud(respuestaEstadosCredito?.data?.solicitud[0]);

          if (respuestaEstadosCredito?.data?.cupos !== null) {
            setDatosAumentoMonto(respuestaEstadosCredito?.data?.cupos);
          }

          setIsLoading(false);
        } else {
          setIsLoading(false);
        }
      } catch (error) {
        setIsLoading(false);
        console.log(error);
      }
    };
    getData();
  }, []);

  if (isLoading) {
    return (
      <Skeleton
        variant="rectangular"
        width="100%"
        height={alturaResolucion}
        sx={{ borderRadius: "32px" }}
      />
    );
  }

  if (datosSolicitud === "null") {
    return (
      <DetalleOpcionGenerica mensaje={"No existe información del cliente."} />
    );
  }

  const columnsData = [
    { id: 1, name: "Motivo" },
    { id: 2, name: "Fecha" },
    { id: 3, name: "Devolver" },
  ];

  const handleSolicitudDevuelta = () => {
    const path = "/credito/flujop";

    history.push(path, {
      state: { identificacion: datosBusqueda.identificacion },
    });
  };

  return (
    <Card
      sx={{
        width: "100%",
        height: alturaResolucion,
        borderRadius: "25px",
        position: "relative",
        "@media (min-width:0px) and (max-width: 500px)": {
          overflow: "scroll",
          height: alturaResolucion + 25,
        },
      }}
    >
      <header className="header-datosSolicitud-information">
        <main className="header-datosSolicitud-information-card">
          <section className="header-datosSolicitud-detalle-titulo">
            {/* <PostAddIcon /> */}
            <div>
              <h3>
                <strong>Información Solicitud</strong>
              </h3>
            </div>
          </section>

          <section
            className={
              datosSolicitud?.aumentoCupo !== true
                ? `header-datosSolicitud-detalle-informacion`
                : `header-datosSolicitud-detalle-informacion-aumento`
            }
          >
            <section>
              <ul>
                <li>
                  <section className="header-datosSolicitud-detalle-filas">
                    <h4>
                      <strong>Fecha Solicitud: </strong>
                    </h4>
                    <h4>
                      {datosSolicitud?.fechaSolicitud
                        ? `${datosSolicitud?.fechaSolicitud}`
                        : ""}
                    </h4>
                  </section>
                </li>

                <li>
                  <section className="header-datosSolicitud-detalle-filas">
                    <h4>
                      <strong>Monto Solicitado: </strong>
                    </h4>
                    <h4>
                      {datosSolicitud?.montoSolicitado
                        ? `$ ${datosSolicitud?.montoSolicitado}`
                        : "$ 0.0"}
                    </h4>
                  </section>
                </li>

                <li>
                  <section className="header-datosSolicitud-detalle-filas">
                    <h4>
                      <strong>Monto Aprobado: </strong>
                    </h4>
                    <h4>
                      {datosSolicitud?.montoAprobado
                        ? `$ ${datosSolicitud?.montoAprobado}`
                        : "$ 0.0"}
                    </h4>
                  </section>
                </li>

                <li>
                  <section className="header-datosSolicitud-detalle-filas">
                    <h4>
                      <strong>Estado: </strong>
                      {datosSolicitud?.estado
                        ? `${datosSolicitud?.estado}`
                        : ""}
                    </h4>
                  </section>
                </li>
              </ul>
            </section>

            {datosSolicitud?.aumentoCupo && (
              <section>
                <ul>
                  <li>
                    <section className="header-datosSolicitud-detalle-filas">
                      <h4>
                        <strong>Aumento de Cupo: </strong>
                      </h4>
                      <h4>
                        {datosSolicitud?.estadoAum
                          ? ` ${datosSolicitud?.estadoAum}`
                          : ""}
                      </h4>
                    </section>
                  </li>

                  <li>
                    <section className="header-datosSolicitud-detalle-filas">
                      <h4>
                        <strong>Aumento Solicitado: </strong>
                      </h4>
                      <h4>
                        {datosSolicitud?.montoSolicitadoAum
                          ? `$ ${datosSolicitud?.montoSolicitadoAum}`
                          : ""}
                      </h4>
                    </section>
                  </li>

                  <li>
                    <section className="header-datosSolicitud-detalle-filas">
                      <h4>
                        <strong>Fecha Solicitud: </strong>
                      </h4>
                      <h4>
                        {datosSolicitud?.fechaSolicitudAum
                          ? `${datosSolicitud?.fechaSolicitudAum}`
                          : ""}
                      </h4>
                    </section>
                  </li>
                </ul>
              </section>
            )}
          </section>
        </main>

        <Divider
          sx={{
            width: "90%",
            margin: "0 auto",
            borderColor: "#acabb9",
            borderWidth: 1,
          }}
        />

        {datosSolicitud?.aumentoCupo &&
          datosSolicitud?.estadoAum !== "NEGADA" && (
            <>
              <main className="header-datosSolicitud-information-card">
                <section className="header-datosSolicitud-detalle-titulo">
                  {/* <PostAddIcon /> */}

                  <h3>
                    <strong>Aumento de Cupo</strong>
                  </h3>
                </section>

                <section className="header-datosSolicitud-detalle-informacion-aumento">
                  {datosAumentoMonto.map((cupos) => (
                    <section>
                      <ul>
                        <li>
                          <section className="header-datosSolicitud-detalle-filas">
                            <h4>
                              <strong>Tipo Cupo:</strong>
                            </h4>
                            <h4>
                              {cupos?.tipoCupo ? `${cupos?.tipoCupo}` : ""}
                            </h4>
                          </section>
                        </li>
                        <li>
                          <section className="header-datosSolicitud-detalle-filas">
                            <h4>
                              <strong>Cupo Anterior:</strong>
                            </h4>
                            <h4>
                              {cupos?.aprobadoAnterior
                                ? `$ ${cupos?.aprobadoAnterior}`
                                : ""}
                            </h4>
                          </section>
                        </li>
                        <li>
                          <section className="header-datosSolicitud-detalle-filas">
                            <h4>
                              <strong>Cupo Actual:</strong>
                            </h4>
                            <h4>
                              {cupos?.aprobado ? `  $ ${cupos?.aprobado}` : ""}
                            </h4>
                          </section>
                        </li>
                        <li>
                          <section className="header-datosSolicitud-detalle-filas">
                            <h4>
                              <strong>Incremento:</strong>
                            </h4>
                            <h4>
                              {cupos?.incremento
                                ? `  $ ${cupos?.incremento}`
                                : ""}
                            </h4>
                          </section>
                        </li>
                      </ul>
                    </section>
                  ))}
                </section>
              </main>

              <Divider
                sx={{
                  width: "90%",
                  margin: "0 auto",
                  borderColor: "#acabb9",
                  borderWidth: 1,
                }}
              />
            </>
          )}
      </header>
    </Card>
  );
};

export default DetalleDatosSolicitud;
